import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const AgreementSignedModal = ({ onClose }) => {
  const navigate = useNavigate();

  const handleModalClose = () => {
    onClose();
    navigate("/account/shared");
  };

  return (
    <div className="agreement-success-modal-overlay">
      <div className="agreement-success-modal-content">
        <FontAwesomeIcon
          icon={faCheckCircle}
          className="agreement-modal-success-icon"
        />
        <h2>Success!</h2>
        <p>The agreement has been reviewed and signed.</p>
        <button
          className="agreement-modal-close-button"
          onClick={handleModalClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default AgreementSignedModal;
